import dataStore from '../store';

export const getRandomKey = () => {
  return Math.random().toString(36).substring(7);
};

export const getIdFromLocalStorage = () => {
  if (typeof localStorage !== 'undefined') {
    return localStorage.getItem('myId');
  }
  return null;
};

export const arraysEqual = (a: any, b: any) => {
  if (a.length !== b.length) return false;
  return a.every((val: any, index: any) => val === b[index]);
};

export const structPipelineData = (data: any) => {
  const rawPaths = data?.pipelines?.inputPaths || [];

  const inputPaths: string[] = rawPaths
    .map((p: string) => {
      return p;
    })
    .sort();

  const inputPath = inputPaths
    .map((p: string, i: number) => (i < inputPaths.length - 1 ? `${p},` : p))
    .join('\n');

  return {
    inputPath,
    multipleLines: inputPaths.length,
    multipleInput: inputPaths.length > 1,
  };
};

export const getBuildVersion = () => {
  let version = '-';
  if (
    process.env.REACT_APP_FRONTEND_VERSION &&
    process.env.REACT_APP_BACKEND_VERSION
  ) {
    version = `version \
      ${process.env.REACT_APP_BACKEND_VERSION}/\
      ${process.env.REACT_APP_FRONTEND_VERSION}`;
  } else {
    version = `version \
      ${dataStore.backendVersion}/\
      ${process.env.REACT_APP_FRONTEND_VERSION}`;
  }
  return version;
};
